// src/components/players/VideoPlayer.js (نسخه نهایی با History Tracking)

import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import useHistoryTracking from '../../hooks/useHistoryTracking'; 

const VideoPlayer = ({ mediaItem, onClose, initialTime }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true); 

    const mediaId = mediaItem?.id;
    const currentTime = videoRef.current?.currentTime || 0; 
    
    useHistoryTracking(
        mediaId, 
        currentTime, 
        isPlaying 
    );
    
    useEffect(() => {
        const video = videoRef.current;
        if (!video || !mediaItem) return;

        if (initialTime > 0) {
            video.currentTime = initialTime;
        }
        
        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);
        const handleEnded = () => onClose(); 
        
        video.addEventListener('play', handlePlay);
        video.addEventListener('pause', handlePause);
        video.addEventListener('ended', handleEnded);

        return () => {
            video.removeEventListener('play', handlePlay);
            video.removeEventListener('pause', handlePause);
            video.removeEventListener('ended', handleEnded);
        };
    }, [mediaItem, onClose, initialTime]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    const handleVideoError = (e) => {
        const error = e.target.error;
        if (error && error.code === 4) {
            // لینک منقضی شده — silently ignore
        }
    };

    if (!mediaItem) return null;

    return (
        <div 
            className="fixed inset-0 z-[30] bg-black/80 flex items-center justify-center p-4 rtl"
            onClick={onClose} 
        >
            <div 
                className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden shadow-2xl"
                onClick={handleContentClick}
            >
                <button 
                    onClick={onClose}
                    className="absolute top-2 right-2 z-20 p-1.5 bg-gray-800/50 text-white rounded-full hover:bg-red-600 transition-colors"
                    title="بستن (Esc)"
                >
                    <X size={24} />
                </button>

                <div className="absolute top-0 left-0 right-0 z-10 p-4 bg-gradient-to-b from-black/60 to-transparent">
                    <h3 className="text-[12px] font-bold text-white truncate">
                        {mediaItem.title || 'پخش ویدیو'}
                    </h3>
                </div>

                <video
                    ref={videoRef}
                    src={mediaItem.url} 
                    controls 
                    autoPlay 
                    className="w-full h-auto max-h-[85vh] aspect-video"
                    onError={handleVideoError}
                >
                    مرورگر شما از تگ ویدیو پشتیبانی نمی‌کند.
                </video>
            </div>
        </div>
    );
};

export default VideoPlayer;